<template>
  <!-- 弹出框 -->
  <a-modal
    v-model="modal.visible"
    :title="modal.title"
    :width="800"
    @ok="handleOk"
    @cancel="cancel"
    :confirm-loading="confirmLoading"
  >
    <a-form-model
      ref="ruleForm"
      :model="formData"
      :rules="rules"
      :label-col="{ span: 6 }"
      :wrapper-col="{ span: 18 }"
    >
      <a-row :gutter="24">
        <a-col :sm="24" :md="12">
          <a-form-model-item label="服务名称" prop="descript"
            ><a-input v-model="formData.descript" :maxLength="20"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="代码" prop="code"
            ><a-input v-model="formData.code" disabled
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="服务id" prop="serviceId"
            ><a-input v-model="formData.serviceId"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12">
          <a-form-model-item label="服务url" prop="url"
            ><a-input v-model="formData.url"
          /></a-form-model-item>
        </a-col>
        <a-col :sm="24" :md="12"
          ><a-form-model-item label="匹配路径" prop="route"
            ><a-input v-model="formData.route"
          /></a-form-model-item>
        </a-col>
        <a-col :span="24">
          <a-form-model-item
            :label-col="{ span: 3 }"
            :wrapper-col="{ span: 21 }"
            label="备注"
            prop="remark"
            ><a-input v-model="formData.remark" type="textarea"
          /></a-form-model-item>
        </a-col>

        <a-col :span="12">
          <a-form-model-item
            label="是否停用"
            :label-col="{ span: 8 }"
            :wrapper-col="{ span: 12 }"
          >
            <a-switch
              checked-children="是"
              un-checked-children="否"
              :checked="formData.isHalt == 'T' ? true : false"
              @change="onChange('isHalt')"
            />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="排序" prop="listOrder">
            <a-input-number
              v-model="formData.listOrder"
              :min="1"
              :max="99999"
            />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
  </a-modal>
</template>

<script>
export default {
  name: "SystemServiceInfo",
  data() {
    return {
      confirmLoading: false,
      //弹出框参数
      modal: {
        visible: false,
        title: "",
        type: "add"
      },
      //form
      formData: {
        code: "",
        descript: "",
        serviceId: "",
        url: "",
        route: "",
        remark: "",
        isHalt: "F",
        listOrder: 1
      },
      //form rules
      rules: {
        descript: [
          {
            required: true,
            message: "请输入服务名称",
            trigger: "change"
          }
        ],
        serviceId: [
          {
            required: true,
            message: "请输入服务id",
            trigger: "change"
          }
        ],
        url: [
          {
            required: true,
            message: "请输入服务url",
            trigger: "change"
          }
        ],
        route: [
          {
            required: true,
            message: "请输入匹配路径",
            trigger: "change"
          }
        ]
      }
    };
  },
  created() {},
  methods: {
    showModal(type, data) {
      this.modal.visible = true;
      this.modal.title = type == "add" ? "添加服务" : "编辑服务";
      this.modal.type = type;
      if (data && type == "edit") {
        this.formData = Object.assign({}, data);
      }
    },
    onChange(column) {
      if (this.formData[column] == "T") {
        this.formData[column] = "F";
      } else {
        this.formData[column] = "T";
      }
    },
    cancel() {
      this.formData = {
        code: "",
        descript: "",
        serviceId: "",
        url: "",
        route: "",
        remark: "",
        isHalt: "F",
        listOrder: 1
      };
      this.confirmLoading = false;
      this.$refs.ruleForm.resetFields();
      this.modal.visible = false;
    },
    /**
     * 保存
     */
    handleOk() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let param = Object.assign({}, this.formData);
          this.confirmLoading = true;
          let action = "saveSystemService";
          if (this.modal.type == "edit") {
            action = "modifySystemService";
          }
          this.$http.systemBksApi[action](param)
            .then(res => {
              if (res.result == 0) {
                this.cancel();
                this.$emit("success");
                this.$message.success(res.msg);
              }
            })
            .finally(() => {
              this.confirmLoading = false;
            });
        }
      });
    }
  }
};
</script>

<style lang="less">
.default .ant-form-item-label {
  word-break: break-all;
  word-break: normal;
  white-space: pre-wrap;
  line-height: 25px;
}
</style>
